// Packages:
import styled from 'styled-components'


// Exports:
export const FieldName = styled.div`
  margin-bottom: 0.5rem;
  font-weight: 600;
`